import { Tooltip } from 'antd';
import React, { useState } from 'react';
import { NoPackageAvailable, select_arrow } from '../../../assets/images';
import EmptyListCard from './EmptyListCard';

const PackageSelector = ({options=[], handleSelect, disabled=false}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedName, setSelectedName] = useState('')

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const getName = (id) => {
    let item = options.find(item => item.id === id)
    return item.name
  }

  const handleOptionSelect = (option) => {
    handleSelect(option)
    setSelectedName(getName(option))
    setSelectedOption(option);
    setIsOpen(false);
  };

  const gettitleText = (e) => {
    if(!e.can_be_utilised && !e.availed_package){
      return`Package can't be utilised`
    }
    else if(!e.can_be_utilised && e.availed_package){
      return`Package already booked`
    } else {
      return ''
    }
  }

  const getList = () => {
    return options.map((option, i) => {
      let titleText = gettitleText(option);
      return (
        <div key={option.id} onClick={() => !(titleText?.length > 0) && handleOptionSelect(option.id)} className={`px-3 py-1 hover:bg-gray-100 w-full my-1 ${titleText?.length > 0  ? 'cursor-not-allowed' : 'cursor-pointer ' }`}>
          {titleText?.length > 0 ? <Tooltip placement="topLeft" title={titleText} key={i}>{option.name}{" "}</Tooltip> : option.name }
        </div>
      )}
    )
  }

  const getEmptyList = () => {
    return ( 
          <EmptyListCard
            svgsrc={NoPackageAvailable}
            svgClasses='h-16'
            classes='my-4'
            title='No packages found'
            subTitleClasses='w-72'
            subTitle='Currently there are no packages available for this person in this category.'
            />
            )
  }

  return (
    <div className=''>
      <div className={`border border-gray-275 bg-white flex rounded-ds-sm py-2 px-3  ${disabled ? 'cursor-not-allowed': 'cursor-pointer'}`}>
        <input
          className={`select w-full placeholder-gray-300 cursor-pointer ${selectedName.length > 0 ? 'text-gray-700 font-semibold': 'font-semibold'} ${disabled ? 'cursor-not-allowed': 'cursor-pointer'}`}
          style={{ borderColor: 'transparent'}}
          type="text"
          value={selectedName ? selectedName : ''}
          placeholder="Select a package"
          readOnly
          onClick={toggleDropdown}
          disabled={disabled}
        />
        <img src={select_arrow} alt='arrow-icon' className={`inline-block mr-1 cursor-pointer transform transition-colors ease-in-out duration-500 ${ isOpen ? 'rotate-180' : ''} ${disabled ? 'cursor-not-allowed': 'cursor-pointer'}`} onClick={toggleDropdown}/>
      </div>
      {isOpen && (
        <div className={`border border-gray-300 bg-white shadow-ds-md rounded-ds-sm w-full text-gray-600 text-ts-md overflow-auto scroll-smooth my-1 ${options.length > 4 ? 'h-44' : 'h-auto'}`}>
          {options.length > 0 ? getList() : getEmptyList()}
        </div>
      )}
    </div>
  );
};

export default PackageSelector;
